import { useRef } from "react";
import { UseDisclosureReturn } from "@chakra-ui/react";
import { useCommentsForEntityInfiniteQuery } from "src/api/client/comment-v2.api";
import { IParentComment } from "src/components/pages/news/components/news-write-comment-modal-content";

interface IUseComments {
    entityId: string;
    modalProps: UseDisclosureReturn;
}

export const useComments = ({ entityId, modalProps }: IUseComments) => {
    const { isLoading, isFetchingNextPage, isError, isSuccess, data, fetchNextPage, hasNextPage } = useCommentsForEntityInfiniteQuery(entityId);

    const parentCommentRef = useRef<IParentComment | undefined>(undefined);

    // Reset Parent Comment directly
    if (!modalProps.isOpen) {
        parentCommentRef.current = undefined;
    }

    const setParentComment = (comment: IParentComment | undefined) => {
        parentCommentRef.current = comment;
    };

    return {
        fetchNextPage,
        setParentComment,
        hasNextPage,
        comments: data?.pages.flatMap(item => item.comments),
        parentComment: parentCommentRef.current,
        isError,
        totalComments: data?.pages[0].commentsCount ?? 0,
        isSuccess,
        isLoading: isLoading || isFetchingNextPage,
    };
};
